import { render, staticRenderFns } from "./NewUserCheckout.vue?vue&type=template&id=20825eb8&scoped=true"
import script from "./NewUserCheckout.vue?vue&type=script&lang=js"
export * from "./NewUserCheckout.vue?vue&type=script&lang=js"
import style0 from "./NewUserCheckout.vue?vue&type=style&index=0&id=20825eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20825eb8",
  null
  
)

export default component.exports